import {defineMessages} from 'react-intl';

export default defineMessages({
	cta: {
		id: 'loadMoreButton.cta',
		defaultMessage: 'Load more'
	},
	total: {
		id: 'totalLoadMore.total',
		defaultMessage: '<tag>{itemsLoaded}</tag> of <tag>{items}</tag> items'
	}
});
